export default function ReportError() {
  return (
    <div className="max-w-xl rounded-xl border bg-white p-8 shadow-md">
      <h1 className="mb-4 text-4xl font-semibold">Report generation failed</h1>
      <p className="mb-4 text-lg">
        Something went wrong while generating the report. Please, contact the
        staff to analyse the problem. You can still use the chat, but the report
        will not be available as a source of information.
      </p>
    </div>
  );
}
